import { ServicePlus } from './ServicePlus';
import { OperationException } from './OperationException';
import { EntityField } from './EntityField';
import { ServiceLocator } from "../ServiceLocator";
import { UtilService } from '../services/util.service';
// import { concat } from 'rxjs/operator/concat';
declare var $: any;
// ServicePlus param specification. Performs self-validation for operations
export class OperationParam {

    // ADN or Condition field name, make sure the Field exists during evaluation time
    Field: string;

    // Evaluation comparator type, if not required use eOperator.None
    Operator: eOperator;

    // Compare value to evaluate against EntityFields of ServicePlus.Conditions or ServicePlus.Data using the Operator statement
    CompareValue: string;

    // Flag for UI to enable form fields required validation
    FormRequired: boolean;

    // Concats this Param with another using AND or OR operator
    ConcatOperator: eConcatOption;

    // Param name to display for UI
    DisplayName: string;

    // Param description for documentation purposes
    Description: string;

    // Flag for skip this param during validation time
    IgnoreValidate: boolean;

    DefaultValue: any;

    Group: number;

    // Internal class Util
    componentsMap: any = null;

    constructor(field: string, operator: eOperator, compareValue: string = null, formRequired: boolean = false, displayName: string = null,
        ignoreValidate: boolean, concatOperator: eConcatOption, defaultValue: any, pGroup: number) {
        this.Field = field;
        this.Operator = operator;
        this.CompareValue = compareValue;
        this.FormRequired = formRequired;
        this.DisplayName = displayName;
        this.ConcatOperator = eConcatOption.AND;
        this.IgnoreValidate = ignoreValidate;
        this.ConcatOperator = concatOperator;
        this.DefaultValue = defaultValue;
        this.Group = pGroup;
        this.componentsMap = {};
    }

    public IsConditionParam(): boolean {
        return this.Field.startsWith("C_");
    }

    public GetRawName(): string {
        if (this.IsConditionParam())
            return this.Field.substr(2);
        return this.Field;
    }

    public GetDefaultValue(): string {
        return (this.DefaultValue === "@null" ? null : this.DefaultValue);
    }

    public static BuildOperationParam(params: any): OperationParam[] {
        let newParams: OperationParam[] = [];
        for (let param of params)
            newParams.push(new OperationParam(param.Field, param.Operator, param.CompareValue, param.FormRequired,
                param.DisplayName, param.IgnoreValidate, param.ConcatOperator, param.DefaultValue, param.Group));

        return newParams;
    }

    public toString(): string {
        return this.Field + " " + this.Operator + " " + (this.CompareValue ? "(empty)" : this.CompareValue) + ". FormRequired = " + this.FormRequired + ", IgnoreValidate = " + this.IgnoreValidate + ", ConcatOperator = " + this.ConcatOperator + ", DisplayName = " + this.DisplayName + ", Description = " + this.Description;
    }

}

// Concatenation options for validation between diferents params
export enum eConcatOption {
    AND,
    OR
}

// Operations available for ADN field evaluations. Values can be combined to perform different evaluations
export enum eOperator {
    NONE = -1,
    EQUALS = 8,
    GREATER_THAN = 2,
    LOWER_THAN = 4,
    NOT = 1,
    LIKE = 16
}
